import { useState, useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import isOnline from "is-online";

export default function NetworkStatus() {
  const toast = useToast();
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const connected = await isOnline();
      if (!connected) {
        toast({
          title: "Sem conexão de internet",
          description:
            "Por favor, verifique sua conexão de internet e tente novamente.",
          status: "error",
          isClosable: true,
        });
      } else {
        setIsConnected(true);
        if (!isConnected) {
          toast({
            title: "Conexão estabelecida",
            description: "Sua conexão com a internet foi restabelecida.",
            status: "success",
            isClosable: true,
          });
        }
      }
    }, 5000);
    return () => clearInterval(intervalId);
  }, [toast, isConnected]);

  return null;
}
